import { ButtonGhost } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';
import { IcRotateCcwRegular } from '@kep/kcds-icons';

export interface ActionBarSettingsResetButtonProps {
  onReset: () => void;
}

export default function ActionBarSettingsResetButton(props: ActionBarSettingsResetButtonProps) {
  const { t } = useTranslation();
  const { onReset } = props;

  return (
    <ButtonGhost size="sm" variant="accent" startIcon={<IcRotateCcwRegular />} onClick={onReset}>
      {t('ui:action.reset')}
    </ButtonGhost>
  );
}
